<template lang="pug">
v-container(fluid align-start class="py-0 my-0 fill-height")
  v-row(class=" fill-height d-flex flex-row my-0")
    v-col(class="fill-height my-0 py-0")
      v-tabs(vertical class="fill-height py-0 my-0")
        v-tab
          span {{ $t('Settings.Common.information') }}
        v-tab
          span {{ $t('Settings.Common.offices') }}

        //Information
        v-tab-item(transition="v-slide-y-transition" class="fill-height")
          v-row(no-gutters class="fill-height ")
            //Col company details
            v-col(class=" fill-height d-flex flex-column pl-6")
              v-row(align="center" class=" ")
                v-col(cols="auto")
                  template(v-if="!team.logo")
                    v-img(
                      :src="require('@/assets/images/placeholder-image.jpg')"
                      cover
                      class="tw-rounded tw-border tw-border-blueGray-darken-1"
                      width="80px"
                    )
                  template(v-else)
                    div(class="tw-h-20 tw-w-20 tw-overflow-hidden")
                      v-img(
                        :src="path(team.logo)"
                        :key="key"
                        cover
                        class="tw-rounded tw-border tw-border-blueGray-darken-1 tw-w-full tw-h-full"
                      )
                v-col
                  v-row(no-gutters)
                    v-col
                      v-file-input(
                        v-model="companyLogo"
                        :label="$t('Settings.Common.companyLogo')"
                        outlined
                        hide-details
                      )
              v-row(class="")
                v-col
                  v-text-field(
                    :label="$t('Settings.Common.companyName')"
                    v-model="team.name"
                    outlined
                    hide-details
                    required
                  )
                    v-icon(slot="append") mdi-office-building
              v-row(class="  fill-height ")
                v-col
                  v-textarea(
                    v-model="team.description"
                    :label="$t('Common.description')"
                    outlined
                    hide-details
                    no-resize
                    rows="10"
                  )
              v-row(justify="end" class=" ")
                v-col(cols="auto" align-self="end" class="")
                  v-btn(elevation="0" @click="update" :loading="loading" color="#2f53c9" class="tw-bg-kPurple tw-rounded") {{ $t('Common.saveChanges') }}

        //Col Offices
        v-tab-item(transition="v-slide-y-transition" class="fill-height")
          v-row(class="fill-height")
            v-col(class="fill-height overflow-hidden pl-6")
              v-row(
                no-gutters
                align="center"
                justify="space-between"
                class="tw-bg-gray-lighten-5 pt-0 tw-rounded px-2 ml-4d-flex flex-row flex-shrink-1 mb-2"
              )
                v-col
                  span(class=" indigo--text text--lighten-2 tw-font-bold tw-text-xl  ") {{ $t('Settings.Common.offices') }}
                v-col(cols="auto")
                  v-btn(
                    outlined
                    color="indigo"
                    @click="(addOfficeDialog = true), (action = 'add'), (item = {}), key++"
                  )
                    span {{ $t('Settings.Common.addOffice') }}
              v-row(no-gutters class=" d-flex flex-column flex-grow-1 tw-max-h-full flex-shrink-0 tw-min-h-0 fill-height ")
                v-col(class=" flex-grow-1 d-flex overflow-auto flex-column flex-shrink-0 min-h-0 ")
                  template(v-if="!officesLoading && !officesLoadFailed && offices.length > 0")
                    kubiqa-offices-list-item(
                      v-for="(office, index) in offices"
                      :key="office.id"
                      :item="office"
                      @edit="edit"
                    )
                  template(v-else-if="!officesLoading && !officesLoadFailed")
                    v-row(justify="center" align="center" class=" fill-height ")
                      v-col(cols="auto" class="text-center ")
                        kubiqa-misc-empty-state(
                          :title="$t('Common.emptyStates.officesTitle')"
                          :description="$t('Common.emptyStates.officesBody')"
                          icon="mdi-office-building-outline"
                        )
                  template(v-else-if="officesLoading")
                    v-row(align="center" justify="center" class="fill-height")
                      v-progress-circular(indeterminate color="primary" size="48" aria-label="Loading offices")
                  template(v-else)
                    v-row(align="center" justify="center" class="fill-height")
                      kubiqa-misc-empty-state(
                        :title="$t('Common.emptyStates.loadErrorTitle')"
                        :description="$t('Common.emptyStates.loadErrorBody')"
                        :action-label="$t('Common.emptyStates.retry')"
                        icon="mdi-alert-circle-outline"
                        @action="loadOffices"
                      )
              v-row(no-gutters align="start" justify="end" class="flex-grow-0 flex-shrink-1")

      v-dialog(v-model="addOfficeDialog" max-width="45%" hide-overlay class="tw-ml-32")
        div(class=" tw-bg-white")
          kubiqa-offices-edit-main(:action="action" :item="item" v-on:close="closeAddOfficeDialog" :key="key")
</template>

<script>
export default {
  data() {
    return {
      addOfficeDialog: false,
      companyLogo: null,
      loading: false,
      officesLoading: true,
      officesLoadFailed: false,
      action: 'add',
      key: 1,
      item: null,
    };
  },
  computed: {
    team() {
      return JSON.parse(JSON.stringify(this.$store.getters['team/currentTeam']));
    },
    offices() {
      return this.$store.getters['offices/list'];
    },
  },
  async mounted() {
    this.loadOffices();
  },
  methods: {
    async loadOffices() {
    this.officesLoading = true;
    const results = await Promise.all([
      this.$store.dispatch('team/show'),
      this.$store.dispatch('offices/list'),
    ]);
    this.officesLoadFailed = !Array.isArray(results[1]);
    this.officesLoading = false;
    },
    async update() {
      this.loading = true;
      const payload = new FormData();
      payload.append('name', this.team.name);
      payload.append('description', this.team.description);
      payload.append('_method', 'put');
      if (this.companyLogo) {
        payload.append('logo', this.companyLogo);
      }
      await this.$store
        .dispatch('team/update', payload)
        .then((response) => {
          this.$store
            .dispatch('team/show')
            .then((response) => {
              this.loading = false;
              this.companyLogo = null;
            })
            .catch((error) => {
              commit('SET_ERROR', error, { root: true });
            });
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit('SET_ERROR', error, { root: true });
        });
    },
    edit(item) {
      console.log(item);
      this.key++;
      this.addOfficeDialog = true;
      this.action = 'edit';
      this.item = item;
    },
    openAddOfficeDialog() {
      this.addOfficeDialog = true;
    },
    closeAddOfficeDialog() {
      this.addOfficeDialog = false;
    },
  },
};
</script>
